<template lang="pug">
  .newsBox
    ul
      li(@click="lookDetails('1')")
        img(:class="[flag1==true?'leftFadeIn':'']" src="https://file.s5yun.com/resources/appico/16161423150407892_dingdingm2.png" alt="")
        .content(:class="[flag1==true?'rightFadeIn':'']")
          h3 签约兰州市税务局——速云软件&钉钉数字一体化解决方案，赋能政务办公
          p 随着从严治党的深入开展，党政机关单位的工作纪律也日益加强，各级纪检部门也加大了对党政机关的监督检查力度，上下班考勤也成为了党政机关人事部门的日常工作。这项看似简单的工作，在实践过程中往往还存在着一些问题。
          span 2021-03-01
      li(@click="lookDetails('2')")
        img(:class="[flag2==true?'leftFadeIn':'']" src="https://file.s5yun.com/resources/appico/16152813755941755_new8.png" alt="")
        .content(:class="[flag2==true?'rightFadeIn':'']")
          h3 2021“陇政钉”新功能培训会
          p 新年新气象，为更好的为甘肃政务服务，“陇政钉”作为甘肃省统一的政务移动办公平台，也进行了功能更新。2020年2月3日，“陇政钉”移动办公系统新功能培训会在兰州速云软件有限公司会议室召开。本次培训会通过线上与线下结合的方式，云会场访问数达4000人次，13个群联播达到了1330人次。
          span 2021-02-03
      li(@click="lookDetails('3')")
        img(:class="[flag3==true?'leftFadeIn':'']" src="https://file.s5yun.com/resources/appico/16152813713034423_new7.png" alt="")
        .content(:class="[flag3==true?'rightFadeIn':'']")
          h3 速云软件成功签约第五届兰州科技成果博览会科技合作与成果交易项目
          p 20日，由甘肃省科学技术厅和兰州市人民政府主办的第五届兰州科技成果博览会科技合作与成果交易项目签约暨颁奖仪式在兰州举行。本届科博会签约总额达65.73亿元，其中，科技产业投资项目46.71亿元，占签约金额的71.06%;科技成果转移转化与技术交易签约金额19.02亿元，比上届科博会增长11.23%。
          span 2020-09-20
      li(@click="lookDetails('4')")
        img(:class="[flag4==true?'leftFadeIn':'']" src="../../assets/images/news/new5.jpg" alt="")
        .content(:class="[flag4==true?'rightFadeIn':'']")
          h3 防疫有我、爱卫同行，创文有我、爱卫同在
          p 打好物业行业创建全国文明城市决胜战，鼓足干劲迎接我市创建全国文明城市的“大考”。7月17日下午，市住建局组织召开物业行业创建全国文明城市攻坚冲刺推进会暨物业行业爱国卫生运动教育培训会。
          span 2020-07-17
      li(@click="lookDetails('5')")
        img(:class="[flag5==true?'leftFadeIn':'']" src="../../assets/images/news/new1.jpg" alt="")
        .content(:class="[flag5==true?'rightFadeIn':'']")
          h3 携手“陇政钉”甘肃省司法厅召开2020年度第一期监狱戒毒人民警察晋升一级、二级监督警衔培训班开班仪式
          p 7月6日，甘肃省甘肃省司法厅利用钉钉（陇政钉）+罗技视频会议设备召开2020年度第一期监狱戒毒人民警察晋升一级、二级警督警衔培训班，开班仪式在省司法行政干警培训中心举行。
          span 2020-07-06
      li(@click="lookDetails('6')")
        img(:class="[flag6==true?'leftFadeIn':'']" src="../../assets/img/goods2.jpg" alt="")
        .content(:class="[flag6==true?'rightFadeIn':'']")
          h3 兰州速云软件科技有限公司成立于2017年
          p 我们是一家有着近二十年IT技术服务的互联网公司，我们为各行各业提供专业的IT技术服务，经过17年的发展壮大，IT行业的飞速发展现已进入一个跨时代的数字化领域；于2017年12月19日我们成立了兰州速云软件科技有限公司，他是一家专为数字化信息建设提供服务的公司。
          span 2020-04-16
</template>

<script>
export default {
  data () {
    return {
      flag1: false,
      flag2: false,
      flag3: false,
      flag4: false,
      flag5: false,
      flag6: false
    }
  },
  methods: {
    lookDetails (flag) {
      var obj = { id: flag }
      this.$router.push({ path: 'newsdetails', query: obj })
    },
    handleScroll () {
      // console.log(window.pageYOffset)
      if (window.pageYOffset >= 80 && window.pageYOffset < 180) {
        this.flag1 = true
      } else if (window.pageYOffset >= 180 && window.pageYOffset < 280) {
        this.flag2 = true
      } else if (window.pageYOffset >= 280 && window.pageYOffset < 380) {
        this.flag3 = true
      } else if (window.pageYOffset >= 380 && window.pageYOffset < 480) {
        this.flag4 = true
      } else if (window.pageYOffset >= 480 && window.pageYOffset < 580) {
        this.flag5 = true
      } else if (window.pageYOffset >= 580) {
        this.flag6 = true
      }
    }
  },
  mounted () {
    document.title = '速云官网'
    window.addEventListener('scroll', this.handleScroll)
  }
}
</script>

<style lang="less" scoped>
  .newsBox{
    ul{
      width: 70%;
      margin: 59px auto 105px;
      overflow: hidden;
      li{
        width: 100%;
        height: 325px;
        margin-bottom: 32px;
        cursor: pointer;
        img{
          width: 42%;
          float: left;
          height: 325px;
          transform: translateX(-1000px);
        }
        .content{
          width: 54%;
          float: left;
          margin-left: 35px;
          transform: translateX(1000px);
          h3{
            font-size: 32px;
            font-weight: 400;
            margin: 20px 0;
            color: #007BF9;
            width: 480px;
            overflow: hidden;
            white-space: nowrap;
          }
          p{
            height: 222px;
            color: #666666;
            line-height: 30px;
            text-align:justify;
          }
          span{
            color: #999;
          }
        }
      }
    }
  }
  // 动画
  .leftFadeIn{
    animation: leftFadeIn 2s ease forwards;
  }
  .rightFadeIn{
    animation: rightFadeIn 2s ease forwards;
  }
  @keyframes leftFadeIn {
    0%{
      opacity: 0;
      transform: translateX(-1000px);
    }
    100%{
      opacity: 1;
      transform: translateX(0);
    }
  }
  @keyframes rightFadeIn {
    0%{
      opacity: 0;
      transform: translateX(1000px);
    }
    100%{
      opacity: 1;
      transform: translateX(0);
    }
  }
</style>
